import { Component, input, computed } from '@angular/core';
import { LogDto } from '@coin/importer/dto/util';

@Component({
  selector: 'importer-import-decision',
  templateUrl: './import-decision.component.html',
  styleUrls: ['./import-decision.component.scss'],
  standalone: false
})
export class ImportDecisionComponent {
  public readonly data = input<LogDto>(undefined);

  decision = computed(() => this.data()?.decision);
}
